import { httpRequest } from "../../../utils/HttpRequest";
import { IPage } from "../../../types/FmsTypes";
import { IMdAppDetail, IMdAppFields, IMdAppSearch } from "./AppTypes";


class AppService {
    /**
     * 新增应用
     * @param insertVo 
     * @returns 
     */
    async insert(insertVo: IMdAppFields) {
        const appInsertUrl = "/auth/app/insert";
        let ret = await httpRequest.post<IMdAppDetail>(appInsertUrl, insertVo);
        return ret;
    }

    /**
     * 更新应用
     * @param insertVo 
     * @returns 
     */
    async update(insertVo: IMdAppFields) {
        const appInsertUrl = "/auth/app/update";
        let ret = await httpRequest.post<IMdAppDetail>(appInsertUrl, insertVo);
        return ret;
    }

    /**
     * 分页查询应用
     * @param insertVo 
     * @returns 
     */
    async page(insertVo: IMdAppSearch) {
        const appInsertUrl = "/auth/app/page";
        let ret = await httpRequest.post<IPage<IMdAppDetail>>(appInsertUrl, insertVo);
        return ret;
    }

    /**
     * 查询应用列表
     * @param insertVo 
     * @returns 
     */
    async find(insertVo: IMdAppFields) {
        const appInsertUrl = "/auth/app/find";
        let { retData } = await httpRequest.post<IMdAppDetail[]>(appInsertUrl, insertVo);
        return retData.map(el => ({
            label: el.name ?? "",
            value: el.code ?? ""
        }))
    }
    /**
     * 查询某个应用
     * @param insertVo
     * @returns 
     */
    async findOne(insertVo: IMdAppSearch) {
        const appInsertUrl = `/auth/app/one`;
        let ret = await httpRequest.post<IMdAppDetail>(appInsertUrl, insertVo);
        return ret;
    }

    /**
     * 同步应用
     * @param syncVo 
     * @returns 
     */
    async sync(syncVo: IMdAppFields) {
        const appPageUrl = "/auth/app/sync";
        return await httpRequest.post<boolean>(appPageUrl, syncVo);
    }


}

export const appService = new AppService();
